/**
 * asNavFor must receive a live react-slick Slider (or null). A remounted/unmounted
 * partner can still sit in state while its innerSlider is already null — that is
 * what throws in react-slick slideHandler.
 */
export const getLiveAsNavForPartner = (slider) =>
  slider && slider.innerSlider ? slider : null;

export const slickGoToIfReady = (slider, index) => {
  const live = getLiveAsNavForPartner(slider);
  if (!live || index == null) {
    return false;
  }
  live.slickGoTo(index);
  return true;
};
